import { BoxGeometry, Mesh, MeshBasicMaterial, Object3D } from "three"
import type { Engine } from "../../core/engine/Engine.type"
import type { EntityGraphNode } from "../../core/engine/EntityGraphNode/EntityGraphNode.type"

export default function makePlaceHolderUnitGroup(
  engine: Engine,
  ent: EntityGraphNode,
  callback: (newGroup: Object3D) => void
): void {
  // const { material: baseMaterial } = pto

  // Tank Group
  const group = new Object3D()

  // Main Hull
  const hullGeometry = new BoxGeometry(12, 6, 16)
  const material = new MeshBasicMaterial({
    wireframe: true,
  })
  const hull = new Mesh(hullGeometry, material)
  hull.position.set(0, 4, 0)
  group.add(hull)

  // group.receiveShadow = false
  // group.castShadow = false

  callback(group)
}

